module.exports = __webpack_public_path__ + "img/victoria-filet.e82d88be.png";